export default __webpack_public_path__ + "static/media/CV.11bec3fe.pdf";